import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import LogoMarquee from "@/components/LogoMarquee";
import About from "@/components/About";
import Stats from "@/components/Stats";
import Expertise from "@/components/Expertise";
import Certifications from "@/components/Certifications";
import Programs from "@/components/Services";
import Labs from "@/components/Labs";
import GlobalDelivery from "@/components/GlobalDelivery";
import Testimonials from "@/components/Testimonials";
import BlogPreview from "@/components/BlogPreview";
import ContactForm from "@/components/ContactForm";
import Footer from "@/components/Footer";
import AskAjayChatbot from "@/components/AskAjayChatbot";

export default function LandingPage() {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-background text-foreground">
      <Navbar />
      <main>
        <Hero />
        <LogoMarquee />
        <About />
        <Stats />
        <Expertise />
        <Certifications />
        <Programs />
        <Labs />
        <GlobalDelivery />
        <Testimonials />
        <BlogPreview />
        <ContactForm />
      </main>
      <Footer />
      <AskAjayChatbot />
    </div>
  );
}
